import { FC } from "react";
import { MainLayout } from "layouts/MainLayout";

import { Home } from "features/Home";

const HomePage: FC = () => {
  return (
    <MainLayout>
      <Home />
    </MainLayout>
  );
};

export default HomePage;
